
import { putPartners } from '../api/putPartners';

export const setPutPartners = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putPartners(params);
            alert('Сохранено');
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}